import styled from "styled-components";
import { Select } from "antd";

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    background-color: ${(props) => (props.$isFiltered ? "rgba(136, 14, 79, 0.1) !important" : "transparent")};
  }
`;

/** Kaart voor mobiele lijsten (kratten, producten); $tone kleurt de linkerrand. */
export const MobileListCard = styled.div`
  padding: 12px 14px;
  margin-bottom: 8px;
  border: 1px solid #f0f0f0;
  ${({ $tone }) => $tone && `border-left: 4px solid ${$tone === "error" ? "#ff4d4f" : "#faad14"};`}
  border-radius: 8px;
  background: #fff;
  cursor: pointer;

  &:active {
    background: #fafafa;
  }
`;
